module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-L-35.f913b83f.png";